import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'
import { alpha, useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

import { RouterLink } from '@menu/components/RouterLink'

import type { MenuItem } from '../../types/menuData'

interface MenuSectionProps {
  title?: string
  items: MenuItem[]
}

const MenuSection = ({ title, items }: MenuSectionProps) => {
  const theme = useTheme()

  return (
    <Box sx={{ mb: 6, pr: 2 }}>
      {title && (
        <Typography variant='h5' sx={{ mb: 4, backgroundColor: theme.palette.primary.main, p: 2, color: 'white' }}>
          {title}
        </Typography>
      )}
      <Grid container spacing={0}>
        {items.map((item, index) => (
          <Grid size={{ xs: 12, sm: 6, md: 12, lg: 12 }} key={index}>
            <RouterLink href={item.href || '#'} style={{ textDecoration: 'none' }}>
              <Card
                sx={{
                  borderRadius: 0,
                  elevation: 0,
                  boxShadow: 0,
                  p: 2,
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  height: '100%',
                  cursor: 'pointer',
                  border: 0,
                  borderColor: `${item.color}.main`,
                  bgcolor: alpha(theme.palette[item.color].main, 0.1),
                  transition: 'all 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 3,
                    bgcolor: alpha(theme.palette[item.color].main, 0.15)
                  }
                }}
              >
                {item.iconSrc ? (
                  <img
                    src={item.iconSrc}
                    alt={item.title}
                    style={{
                      width: '3.5dvh',
                      height: '3.5dvh',
                      marginRight: '16px',
                      objectFit: 'contain'
                    }}
                  />
                ) : (
                  <i
                    className={`${item.icon}`}
                    style={{
                      fontSize: '2.5rem',
                      color: theme.palette[item.color].main,
                      marginRight: '16px'
                    }}
                  />
                )}
                <Typography variant='subtitle2' align='left' sx={{ color: 'text.primary', fontWeight: 500 }}>
                  {item.title}
                </Typography>
              </Card>
            </RouterLink>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default MenuSection
